import { jsx as _jsx } from "react/jsx-runtime";
import { RadioGroup } from '@skbkontur/react-ui';
import { employeeTids } from '../../constants/tids';
import { FieldWrapper } from '../FieldWrapper';
export const Gender = ({ value, onValueChange, labelClassName, disabled }) => {
    const radioItems = [
        ['male', 'Мужской'],
        ['female', 'Женский'],
    ];
    return (_jsx(FieldWrapper, { label: "\u041F\u043E\u043B", labelClassName: labelClassName, children: _jsx(RadioGroup, { inline: true, value: value || undefined, items: radioItems, onValueChange: onValueChange, "data-tid": employeeTids.genderRadioGroup, disabled: disabled }) }));
};
